'use es6';

import { useState } from 'react';
import { useTheme } from 'styled-components';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Flex } from 'foundations-components/components/Flex';
import { NAV_BAR_HEIGHT } from 'foundations-components/transitional/constants';
import AsyncReportsListSideBar from './AsyncReportsListSideBar';
import AsyncReportsListHeader from './AsyncReportsListHeader';
import GlobalSearchPage from './globalSearch/GlobalSearchPage';
import { selectSearchFilter } from '../selectors/reportsSelector';
import SideNavReRenderContext from '../records/SideNavReRenderContext';
import SearchWarningBanner from '../components/fullscreenSearch/SearchWarningBanner';
import { selectGenerativeAIEnabled } from '../selectors/aiSettingsSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HEADING1_HEIGHT = '32px'; // TODO find style token
const CONTENT_AREA_SPACING = '500';

// height = viewport minus navbar and header (padding top - padding bottom - text height - border width)
export const getListingPageContentAreaHeight = theme => {
  return `calc(
    100vh - ${NAV_BAR_HEIGHT} - ${theme.space['500']} - ${theme.space['500']} -
      ${HEADING1_HEIGHT} - ${theme.borderWidth['100']}
  )`;
};
const CustomListingPageWrapper = ({
  children
}) => {
  const {
    templateId,
    reportId
  } = useParams();
  const [sideNavReRender, setShouldReRender] = useState(false);
  const theme = useTheme();
  const searchFilter = useSelector(selectSearchFilter);
  const hasAiSearchSettingsEnabled = useSelector(selectGenerativeAIEnabled);
  const showGlobalSearchPage = searchFilter !== undefined && !reportId;
  const showSRV = templateId || reportId;
  return /*#__PURE__*/_jsxs(SideNavReRenderContext.Provider, {
    value: {
      sideNavReRender,
      updateSideNavReRender: setShouldReRender
    },
    children: [/*#__PURE__*/_jsx(AsyncReportsListHeader, {}), /*#__PURE__*/_jsxs(Flex, {
      blockSize: getListingPageContentAreaHeight(theme),
      children: [/*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        overflowY: "auto",
        padding: CONTENT_AREA_SPACING,
        children: /*#__PURE__*/_jsx(AsyncReportsListSideBar, {
          showGlobalSearchPage: showGlobalSearchPage
        })
      }), /*#__PURE__*/_jsx(Flex, Object.assign({
        flexDirection: "column",
        overflowY: "auto",
        minHeight: 0 // allow flex to shrink so table can scroll
        ,
        flex: 1 // fill remaining space
        ,
        padding: showSRV || showGlobalSearchPage ? '0' : CONTENT_AREA_SPACING
      }, showSRV && {
        backgroundColor: 'fill-surface-recessed'
      }, {
        children: showGlobalSearchPage ? /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "column",
          justifyContent: "space-between",
          blockSize: "100%",
          children: [/*#__PURE__*/_jsx(GlobalSearchPage, {
            search: searchFilter
          }), hasAiSearchSettingsEnabled && /*#__PURE__*/_jsx(SearchWarningBanner, {})]
        }) : children
      }))]
    })]
  });
};
export default CustomListingPageWrapper;